import { useAuth } from "@clerk/clerk-react";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import {
  VaOnboardingRouteToStepName,
  getDefaultVaOnboardingSteps,
} from "schemas/dashboard";

import { useAccountReviewState } from "features/Auth/Onboarding/shared/AccountReviewUpsell";

import { fetcherAuth } from "./api";
import { getSource } from "./tracking";

export const useTracking = () => {
  const { getToken } = useAuth();
  const { currentOrg, setOrganizationVaProfile } = useContext(
    OrganizationUserContext,
  );
  const { canSubmitReview } = useAccountReviewState();
  const trackUserHasOnboarded = async (action: string) => {
    await fetcherAuth(
      getToken,
      `/api/organization/${currentOrg?.id}/onboarding/track`,
      "POST",
      {},
      { action },
    );
  };

  const trackVaStep = async (route: string, skipped?: boolean) => {
    if (!currentOrg) {
      return;
    }
    try {
      const { organizationVaProfile } = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/onboarding/track-va-step`,
        "POST",
        {},
        {
          page: route,
          source: getSource(),
          skipped,
          currentStepName: VaOnboardingRouteToStepName[route],
          steps: getDefaultVaOnboardingSteps(canSubmitReview),
        },
      );
      if (organizationVaProfile) {
        setOrganizationVaProfile(organizationVaProfile);
      }
    } catch (error) {}
  };

  return { trackUserHasOnboarded, trackVaStep };
};
